"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsTwisterBuyBox = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const alert_1 = require("../alert");
const divider_1 = require("../divider");
const page_wrapper_1 = require("../page-wrapper");
const product_twister_1 = require("../product-twister");
const subs_buy_box_1 = require("../subs-buy-box");
const styles_1 = require("./styles");
const SubsTwisterBuyBox = (props) => {
    const { alertMessage } = props;
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const isMobileDevice = () => {
        return deviceType === monera_app_core_1.DeviceType.Mobile || deviceType === monera_app_core_1.DeviceType.MShop;
    };
    if (alertMessage) {
        return isMobileDevice() ? (react_1.default.createElement(styles_1.SubsTwisterBuyBoxAlertMobileWrapper, { "data-cy": 'subs-mobile-buy-box-alert' },
            react_1.default.createElement(alert_1.Alert, { maxWidth: "412px", alertType: "information", descriptionCopy: alertMessage }))) : (react_1.default.createElement(styles_1.SubsTwisterBuyBoxAlertDesktopWrapper, { "data-cy": 'subs-desktop-buy-box-alert' },
            react_1.default.createElement(alert_1.Alert, { maxWidth: "700px", alertType: "information", descriptionCopy: alertMessage })));
    }
    return isMobileDevice() ? react_1.default.createElement(MobileSubsTwisterBuyBox, Object.assign({}, props)) : react_1.default.createElement(DesktopSubsTwisterBuyBox, Object.assign({}, props));
};
exports.SubsTwisterBuyBox = SubsTwisterBuyBox;
const DesktopSubsTwisterBuyBox = (props) => {
    const { id, twisterIsLoading, twister, buyBox } = props;
    return twister && buyBox ? (react_1.default.createElement(styles_1.SubsTwisterBuyBoxDesktopWrapper, { id: id },
        react_1.default.createElement(product_twister_1.ProductTwisterPlus, Object.assign({ "data-cy": 'twister-plus' }, twister, { isLoading: twisterIsLoading })),
        react_1.default.createElement(divider_1.Divider, { margin: "0px -24px", width: "auto" }),
        react_1.default.createElement(subs_buy_box_1.SubsBuyBox, Object.assign({ "data-cy": 'subs-buy-box' }, buyBox, { width: "100%", hideBorders: true, padding: "0px" })))) : null;
};
const MobileSubsTwisterBuyBox = (props) => {
    const { id, twisterIsLoading, twister, buyBox } = props;
    return twister && buyBox ? (react_1.default.createElement(styles_1.SubsTwisterBuyBoxMobileWrapper, { id: id },
        react_1.default.createElement(product_twister_1.ProductTwisterPlus, Object.assign({}, twister, { isLoading: twisterIsLoading })),
        react_1.default.createElement(subs_buy_box_1.SubsBuyBox, Object.assign({}, buyBox, { width: "100%", hideBorders: true, padding: "0px" })))) : null;
};
